import { createFileRoute } from "@tanstack/react-router";
import PatientEligibilityChecklist from "@/pages/PatientEligibilityChecklist";
export const Route = createFileRoute("/patient-eligibility-checklist")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Patient Eligibility Checklist | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Downloadable patient eligibility checklist for physicians referring to Neuro Wellness TMS for TMS, SAINT TMS, and ketamine in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Patient Eligibility Checklist | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Downloadable patient eligibility checklist for physicians referring to Neuro Wellness TMS for TMS, SAINT TMS, and ketamine in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/patient-eligibility-checklist",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/patient-eligibility-checklist",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <PatientEligibilityChecklist />;
}
